import dayjs from 'dayjs';

import { useCurrentUser } from '@/feature/security';

export function useFreezeDate() {
  const { freezeDate } = useCurrentUser();
  const now = dayjs();
  const freezeDayjs = dayjs(freezeDate);
  const isAfterFreezeDate = now.isAfter(freezeDayjs);
  const formattedFreezeDate = freezeDate != null ? freezeDayjs.format('DD.MM.YYYY') : null;
  return { isAfterFreezeDate, formattedFreezeDate };
}
